import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { ITerm } from '../../models/term';
import { FirebaseService } from '../../services/firebase.service';

/**
 * Generated class for the TermPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-term',
  templateUrl: 'term.html',
})
export class TermPage {

  UserDataTerms: ITerm[];

  constructor(public viewCtrl: ViewController,public navCtrl: NavController, public navParams: NavParams, public fireSrv: FirebaseService) {
    this.fireSrv.getTerm().subscribe(res => {
      console.log(res);
      this.UserDataTerms = res;
    });
 
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad TermPage');
  }
  close(){

    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/term/term.ts